// Copyright (c) Move Closer 2022.

import { AnyObject } from '@movecloser/front-core'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import { Inject } from '../../../support'
import { ToastMixin } from '../../shared'

import { AbstractStepPreview } from './AbstractStepPreview'
import { CartModel } from '../contracts'
import { CheckoutServiceType, ICheckoutService } from '../services/checkout'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
@Component
export class AbstractStep extends Mixins(AbstractStepPreview, ToastMixin) {
  @Prop({ type: Object, required: true })
  protected readonly cart!: CartModel

  @Prop({ type: Function, required: true })
  protected readonly nextStep!: CallableFunction

  @Prop({ type: Function, required: true })
  protected readonly onChange!: CallableFunction

  @Inject(CheckoutServiceType)
  protected readonly checkoutService!: ICheckoutService

  /**
   * FIXME - Get rid of setTimeout.
   */
  public updateValues (payload: AnyObject): void {
    for (const [key, value] of Object.entries(payload)) {
      const sIndex = setTimeout(() => {
        this.onChange(key, value)
        clearTimeout(sIndex)
      }, 10)
    }
  }
}
